// extracted by mini-css-extract-plugin
module.exports = {"tagline":"Tagline_tagline__38k28","taglineTitle":"Tagline_tagline-title__rdWsN","description":"Tagline_description__2UGID"};